module.exports = __webpack_public_path__ + "media/svgs/elocal-caret-selected-6f0bcdb5.svg";